module.exports = __webpack_public_path__ + "img/mayotte.89498955.svg";